// extracted by mini-css-extract-plugin
export default {"mainContainer":"ImageBlock_mainContainer__nN+N7"};